module.exports = __webpack_public_path__ + "media/images/pages/ic-filter-0180dfe732b5709e0dff101e68a81506.png";